import { DiNodejs } from 'react-icons/di'

export const NodeTech = () => {
    return (
        <div>
        <DiNodejs />
        <h4>NodeJS</h4>
        </div>
    )
}